<template>
  <div
    class="right_body action_body"
    v-loading="isLoading"
    :element-loading-background="loadingBg"
    :element-loading-text="loadingTxt"
  >
    <span class="btn right_sub_btn del_btn" @click.stop="subCheck" style="margin-right:120px">检查数据</span>
    <span class="btn right_sub_btn save_btn" @click.stop="subSave">提交数据</span>
    <div class="active_rumb">
      <span class="txt">销售订单退货</span>
    </div>

    <div class="coll header_box">
      <h2 class="title">
        <span>抬头信息</span>
      </h2>
      <v-head
        :fromData="fromData"
        :noFromData="noFromData"
        :customerList="this.$store.state.cache.customerList"
        :factoryList="this.$store.state.cache.factoryList"
        :companyList="this.$store.state.cache.companyList"
      ></v-head>
    </div>
    <div class="coll list_content">
      <h2 class="title">
        <span>数据明细</span> 
      </h2>
      <v-list :fromData="fromData" :noFromData="noFromData" ref="listChild"></v-list>
    </div>
    <div class="coll list_content">
      <h2 class="title">
        <span>行项目备注</span>
      </h2>
      <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="textarea"></el-input>
    </div>
  </div>
</template>

<script>
import { customerApi, matterTypeApi, factoryApi, fstockApi } from "api/base.js";
import { CancelOrder } from "api/business.js";
import { company } from "api/system.js";

import vHead from "./components/orderCancel/head.vue";
import vList from "./components/orderCancel/list.vue";


import { mapState, mapActions } from "vuex";
export default {
  components: {
    vHead,
    vList
  },
  data() {
    return {
      check: false,
      textarea: "",
      isLoading: false,
      loadingBg: "rgba(255,255,255,1)",
      loadingTxt: "加载中",
      id: "",
      isChildComponent: false,
      //需要提交的数据
      fromData: {
        details: [] 
      },
      //不需要提交的数据
      noFromData: {}
    };
  },
  //设置校验规则
  vuerify: {
    "fromData.voucherDate": [
      "required" //必填项
      /* {
				test (val) {
					return /\d{4}-\d{1,2}-\d{1,2}/.test(val) && Date.parse(val)
				},
				message: '日期格式不正确 yyyy-mm-dd'
			}, */
    ]
  },
  computed: {
    errors() {
      return this.$vuerify.$errors;
    }
  },
  watch: {
    fromData: function(val, old) {
      console.log(val, old);
    }
  },
  created() {
    this.$store.state.cache.TypeID=200 //选择销售订单数据
  },
  methods: {
    handleClick(tab, event) {},
    //关闭弹窗
    handleClose() {},

    //保存提交数据
    async subSave() {
      this.$refs.listChild.onSubmitSaves();
      let vm = this;
      if (vm.check == true) {
        if (!this.fromData.saleId) {
          this.$message.error("请选择销售订单");
          return false;
        }
        if (!this.fromData.companyDesc) {
          this.$message.error("请选择公司");
          return false;
        }
        if (!this.fromData.customerDesc) {
          this.$message.error("请选择客户");
          return false;
        }
        if (!this.$store.state.cache.selectedMatterSaleCancel.length) {
          this.$message.error("请选择物料明细");
          return false;
        }
        // let isTrue = true;
        // this.$store.state.cache.selectedMatterSaleCancel.forEach(item => {
        //   if (!item.currentReturnNum) {
        //     vm.$message.error("请输入退货数量");
        //     isTrue = false;
        //     return false;
        //   }
        // });
        // if (!isTrue) return false;
        this.fromData.details = [];
        this.fromData.details = this.$refs.listChild.PurchOrderList;
        if (this.fromData.details.length == 0) {
          this.$message.error("请勾选需要提交的数据明细！");
          return false;
        }
        let isTrue = true;
        this.fromData.details.forEach(item => {
          if (!item.currentReturnNum) {
            vm.$message.error("请输入退货数量");
            isTrue = false;
            return false;
          }
        });
        if (!isTrue) return false;
        console.log(this.fromData);
        this.fromData.voucherDate = this.$moment(
          this.fromData.voucherDate
        ).format("YYYY-MM-DD");
        this.fromData.postingDate = this.$moment(
          this.fromData.postingDate
        ).format("YYYY-MM-DD");
        this.isLoading = true;
        this.loadingBg = "rgba(255,255,255,0.5)";
        this.loadingTxt = "数据处理中...";
        let res = await this.$post(CancelOrder.send, this.fromData);
        let json = JSON.stringify(this.fromData);
        console.log(json);
        this.isLoading = false;
        if (res.status) {
          console.log(res);
          this.$confirm(
            "物料凭证 " + res.data.materialVoucherCode + " 已过账",
            "提示",
            {
              confirmButtonText: "继续",
              cancelButtonText: "退出",
              type: "success"
            }
          )
            .then(() => {
              //凭证和过账默认今天
              let nowData = new Date();
              this.fromData = {
                voucherDate: nowData,
                postingDate: nowData,
                details: []
              };
              this.textarea = ''
              this.noFromData = {};
              vm.$store.state.cache.selectedMatterSaleCancel = [];
              vm.$router.push({ name: "business-sale-orderCancel" });
            })
            .catch(() => {
              vm.$router.push({ name: "home" });
              vm.fromData.saleId = ''
              vm.fromData.companyDesc = ''
              vm.fromData.customerDesc = ''
              vm.fromData.refRoucherStatus = ''
              vm.fromData.voucherHeaderTxt = ''
              vm.$store.state.cache.selectedMatterSaleCancel = [];
            });
        } else {
          this.$message.error(res.errorMsg);
        }
      } else {
        this.$message.error("请先检查数据，再进行提交");
      }
    },

    //检查数据
    async subCheck() {
      this.$refs.listChild.onSubmitSaves();
      let vm = this;
      if (!this.fromData.saleId) {
        this.$message.error("请选择销售订单");
        return false;
      }
      if (!this.fromData.companyDesc) {
        this.$message.error("请选择公司");
        return false;
      }
      if (!this.fromData.customerDesc) {
        this.$message.error("请选择客户");
        return false;
      }
      // if(!this.fromData.refRoucherStatus){
      // 	this.$message.error('请选择状态');
      // 	return false;
      // }
      // if(!this.fromData.voucherHeaderTxt){
      // 	this.$message.error('请选择抬头文本');
      // 	return false;
      // }

      if (!this.$store.state.cache.selectedMatterSaleCancel.length) {
        this.$message.error("请选择物料明细");
        return false;
      }
      this.fromData.details = [];
      // 	let isTrue = true;
      // 	this.$store.state.cache.selectedMatterSaleCancel.forEach((item) => {
      // 		if(!item.currentReturnNum){
      // 			vm.$message.error('请输入退货数量');
      // 			isTrue = false;
      // 			return false;
      // 		}

      // 	});
      // if(!isTrue) return false;

      this.fromData.details = this.$refs.listChild.PurchOrderList;
      if (this.fromData.details.length == 0) {
        this.$message.error("请勾选需要检查的数据明细！");
        return false;
      }
      let isTrue = true;
      this.fromData.details.forEach(item => {
        if (!item.currentReturnNum) {
          vm.$message.error("请输入退货数量");
          isTrue = false;
          return false;
        }
      });
      if (!isTrue) return false;
      console.log(this.fromData.details);
      this.isLoading = true;
      this.loadingBg = "rgba(255,255,255,0.5)";
      this.loadingTxt = "数据处理中...";
      let res = await this.$post(CancelOrder.check, this.fromData);
      let json = JSON.stringify(this.fromData);
      console.log(json);
      this.isLoading = false;
      if (res.status) {
        let verifyDesc = res.data.verifyResult;
        verifyDesc = "null" ? "检查数据无误,请提交数据" : verifyDesc;
        console.log(verifyDesc);
        this.$confirm(verifyDesc, "提示", {
          confirmButtonText: "继续",
          cancelButtonText: "退出",
          type: "success"
        })
          .then(() => {
            vm.check = true;
            //凭证和过账默认今天
            let nowData = new Date();
            vm.$router.push({ name: "business-sale-orderCancel" });
          })
          .catch(() => {
            vm.fromData.saleId = ''
            vm.fromData.companyDesc = ''
            vm.fromData.customerDesc = ''
            vm.fromData.refRoucherStatus = ''
            vm.fromData.voucherHeaderTxt = ''

            vm.$store.state.cache.selectedMatterSaleCancel = [];
            vm.$router.push({ name: "business-sale-orderCancel" });
          });
      } else {
        this.$message.error(res.errorMsg);
      }
    }
  }
};
</script>

<style lang="stylus" scoped></style>
